import SecondaryReadingPaneTabData from './SecondaryReadingPaneTabData';

export enum TabType {
    Primary,
    OverflowMenu,
    SecondaryReadingPane,
    Compose,
    FloatingChat,
    SxS,
}

export const enum TabState {
    Hidden,
    Minimized,
    Active,
    Popout,
}

interface TabViewStateBase {
    id: string;
    state: TabState;
    startTime?: number;
    parentTabId?: string;
    blink: boolean;
    sxsId: string;
}

export interface PrimaryReadingPaneTabViewState extends TabViewStateBase {
    type: TabType.Primary;
}

export interface SecondaryReadingPaneTabViewState extends TabViewStateBase {
    type: TabType.SecondaryReadingPane;
    data: SecondaryReadingPaneTabData;
}

export interface OverflowTabViewState extends TabViewStateBase {
    type: TabType.OverflowMenu;
    data: TabViewState[];
}

export interface ComposeTabViewState extends TabViewStateBase {
    type: TabType.Compose;
    data: string /* composeId */;
}

export interface FloatingChatTabViewState extends TabViewStateBase {
    type: TabType.FloatingChat;
    data: string /* conversationId */;
    isChatActive: boolean;
}

export interface SxSTabViewState extends TabViewStateBase {
    type: TabType.SxS;
}

type TabViewState =
    | PrimaryReadingPaneTabViewState
    | SecondaryReadingPaneTabViewState
    | OverflowTabViewState
    | ComposeTabViewState
    | FloatingChatTabViewState
    | SxSTabViewState;

export default TabViewState;
